module.exports = __webpack_public_path__ + "static/img/IMG_20240811_102108.b89ca484.jpg";